'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): stage.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Stage = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'stage';
  var DATA_KEY = 'bs.stage';
  var VERSION = 'v4.0.0-alpha.6';
  var DATA_API = '[data-toggle="stage"]';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Default = {
    easing: 'cubic-bezier(.2,.7,.5,1)',
    duration: 300,
    delay: 0,
    distance: 250,
    hiddenElements: '#sidebar'
  };

  var Event = {
    TOUCHMOVE: 'touchmove' + EVENT_KEY,
    KEYDOWN: 'keydown' + EVENT_KEY,
    OPEN: 'open' + EVENT_KEY,
    OPENED: 'opened' + EVENT_KEY,
    CLOSE: 'close' + EVENT_KEY,
    CLOSED: 'closed' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    STAGE_OPEN: 'stage-open',
    HIDDEN: 'hidden'

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Stage = function () {
    function Stage(element, config) {
      _classCallCheck(this, Stage);

      if (!Util.supportsTransitionEnd()) return;

      this._element = element;
      this._config = config;
    }

    // getters

    _createClass(Stage, [{
      key: '_isOpen',


      // private

      value: function _isOpen() {
        return $(this._element).hasClass(ClassName.STAGE_OPEN);
      }
    }, {
      key: '_complete',
      value: function _complete() {
        $(document.body).css('overflow', 'auto');

        if ('ontouchstart' in document.documentElement) {
          $(document).off(Event.TOUCHMOVE);
        }

        $(this._config.hiddenElements).addClass(ClassName.HIDDEN);

        $(this._element).removeClass(ClassName.STAGE_OPEN).css({
          '-webkit-transition': '',
          '-ms-transition': '',
          'transition': ''
        }).css({
          '-webkit-transform': '',
          '-ms-transform': '',
          'transform': ''
        }).trigger(Event.CLOSED);
      }

      // public

    }, {
      key: 'toggle',
      value: function toggle() {
        if (this._isOpen()) {
          this.close();
        } else {
          this.open();
        }
      }
    }, {
      key: 'open',
      value: function open() {
        var _this = this;

        $(document.body).css('overflow', 'hidden');

        if ('ontouchstart' in document.documentElement) {
          $(document).on(Event.TOUCHMOVE, function (e) {
            e.preventDefault();
          });
        }

        $(this._config.hiddenElements).removeClass(ClassName.HIDDEN);

        $(window).one(Event.KEYDOWN, $.proxy(function (e) {
          e.which == 27 && this.close();
        }, this));

        $(this._element).on(Event.CLICK, $.proxy(this.close, this)).trigger(Event.OPEN).addClass(ClassName.STAGE_OPEN);

        if (!Util.supportsTransitionEnd()) {
          $(this._element).css({
            'left': this._config.distance + 'px',
            'position': 'relative'
          }).trigger(Event.OPENED);
          return;
        }

        $(this._element).css({
          '-webkit-transition': '-webkit-transform ' + this._config.duration + 'ms ' + this._config.easing,
          '-ms-transition': '-ms-transform ' + this._config.duration + 'ms ' + this._config.easing,
          'transition': 'transform ' + this._config.duration + 'ms ' + this._config.easing
        });

        this._element.offsetWidth; // force reflow

        $(this._element).css({
          '-webkit-transform': 'translateX(' + this._config.distance + 'px)',
          '-ms-transform': 'translateX(' + this._config.distance + 'px)',
          'transform': 'translateX(' + this._config.distance + 'px)'
        }).one(Util.TRANSITION_END, function () {
          $(_this._element).trigger(Event.OPENED);
        }).emulateTransitionEnd(this._config.duration);
      }
    }, {
      key: 'close',
      value: function close() {
        $(window).off(Event.KEYDOWN);

        if (!Util.supportsTransitionEnd()) {
          $(this._element).trigger(Event.CLOSE).css({ 'left': '', 'position': '' }).off(Event.CLICK);

          return this._complete();
        }

        $(this._element).trigger(Event.CLOSE).off(Event.CLICK).css({
          '-webkit-transform': 'none',
          '-ms-transform': 'none',
          'transform': 'none'
        }).one(Util.TRANSITION_END, $.proxy(this._complete, this)).emulateTransitionEnd(this._config.duration);
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $(this);
          var data = $this.data(DATA_KEY);
          var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

          if (!data) $this.data(DATA_KEY, data = new Stage(this, _config));
          if (typeof config === 'string') data[config]();
        });
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Stage;
  }();

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Stage._jQueryInterface;
  $.fn[NAME].Constructor = Stage;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Stage._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, DATA_API, function () {
    var config = $(this).data();
    var $target = $(this.getAttribute('data-target'));

    if (!$target.data(DATA_KEY)) {
      $target.stage(config);
    }

    $target.stage('toggle');
  });

  return Stage;
}(jQuery);